import { OperationEnum, OperationsMapper } from '../types';
import {
  useDateBetweenOperation,
  useDateOnOperation,
  useDateOnOrAfterOperation,
  useDateOnOrBeforeOperation,
} from './operations';
import { BetweenDateOperationPayload, SingleDateOperationPayload } from './types';

export * from './operations';
export * from './types';

export const DateOperationsMapper: OperationsMapper = {
  [OperationEnum.On]: (value) => useDateOnOperation(value as SingleDateOperationPayload),
  [OperationEnum.OnOrAfter]: (value) => useDateOnOrAfterOperation(value as SingleDateOperationPayload),
  [OperationEnum.OnOrBefore]: (value) => useDateOnOrBeforeOperation(value as SingleDateOperationPayload),
  [OperationEnum.BetweenDate]: (value) => useDateBetweenOperation(value as BetweenDateOperationPayload),
};
